import { formValidationMessages } from '@/pages/products/all/products.messages';
import { IntlShape } from 'react-intl';
import * as z from 'zod';

export const templateFormSchema = (t: IntlShape) => {
  const chineseCharPattern = /[\u4e00-\u9fff]/;

  return z.object({
    name: z
      .string()
      .transform((value) => value.trim())
      .pipe(
        z
          .string()
          .min(1, {
            message: t.formatMessage(formValidationMessages.minimumLength, {
              minLength: 1,
            }),
          })
          .max(60, {
            message: t.formatMessage(formValidationMessages.maximumLength, {
              maxLength: 60,
            }),
          }),
      )
      .refine(
        (value) => {
          if (!value) return true;
          return !chineseCharPattern.test(value);
        },
        {
          message: t.formatMessage(formValidationMessages.invalidCharacters),
        },
      ),
    description: z
      .string()
      .transform((value) => value.trim())
      .pipe(
        z
          .string()
          .min(1, {
            message: t.formatMessage(formValidationMessages.minimumLength, {
              minLength: 1,
            }),
          })
          .max(260, {
            message: t.formatMessage(formValidationMessages.maximumLength, {
              maxLength: 260,
            }),
          }),
      )
      .refine(
        (value) => {
          if (!value) return true;
          return !chineseCharPattern.test(value);
        },
        {
          message: t.formatMessage(formValidationMessages.invalidCharacters),
        },
      ),
    copyAnswersFrom: z.string().optional(),
  });
};
